import api, { getApiOrigin } from "./axiosConfig";

export interface ImportRowErrorDto {
  row: number;
  message: string;
}

export interface ImportPreviewRowDto {
  row: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  state: string;
  dateOfBirth: string;
  isValid: boolean;
  messages: string[];
}

export interface ImportValidationResultDto {
  fileName: string;
  totalRows: number;
  validRows: number;
  errorRows: number;
  creditRepairCloudFormat: boolean;
  errors: ImportRowErrorDto[];
  previewRows: ImportPreviewRowDto[];
}

export interface ImportResultDto {
  importHistoryId?: string | null;
  fileName: string;
  totalRows: number;
  successCount: number;
  errorCount: number;
  status: string;
  errors: ImportRowErrorDto[];
}

export interface ImportHistoryDto {
  id: string;
  fileName: string;
  totalRows: number;
  successCount: number;
  errorCount: number;
  status: string;
  errors: ImportRowErrorDto[];
  createdAt: string;
}

export const importApi = {
  validate: (file: File, creditRepairCloud: boolean) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("creditRepairCloud", creditRepairCloud ? "true" : "false");
    return api.post<ImportValidationResultDto>("/import/validate", fd).then((r) => r.data);
  },

  importCsv: (file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post<ImportResultDto>("/import/clients", fd).then((r) => r.data);
  },

  importCreditRepairCloud: (file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post<ImportResultDto>("/import/credit-repair-cloud", fd).then((r) => r.data);
  },

  history: () => api.get<ImportHistoryDto[]>("/import/history").then((r) => r.data),

  downloadTemplate: async (): Promise<void> => {
    const origin = getApiOrigin();
    const token = localStorage.getItem("token");
    const res = await fetch(`${origin}/api/import/template`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      throw new Error("Download failed");
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "intelliwarrior-clients-template.csv";
    a.click();
    URL.revokeObjectURL(url);
  },
};
